import { render, staticRenderFns } from "./searchPackageComponent.vue?vue&type=template&id=1d562401"
import script from "./searchPackageComponent.vue?vue&type=script&lang=js"
export * from "./searchPackageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports